import {store} from "./utils/store.ts";
import React from "react";
import ReactDOM from "react-dom/client";
import "./locale/index";
import "./index.scss";

import * as serviceWorker from "./serviceWorker";
import {Provider as ReduxProvider} from "react-redux";
import {HookedBrowserRouter, navigate} from "./utils/router";
import {AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN} from "./utils/constants";
import {AppState, Auth0Provider} from "@auth0/auth0-react";
import {KToaster} from "@kopjra/uikit";
import {App} from "./components/App.tsx";

window.global ||= window;

const onRedirectCallback = (appState?: AppState) => {
    // Use the router's history module to replace the url
    navigate(appState?.returnTo || window.location.pathname, {replace: true});
};

ReactDOM.createRoot(document.getElementById('root')!).render(
    <ReduxProvider store={store}>
        <Auth0Provider
            authorizationParams={{redirect_uri: window.location.origin, audience: AUTH0_AUDIENCE,}}
            onRedirectCallback={onRedirectCallback}
            domain={AUTH0_DOMAIN}
            clientId={AUTH0_CLIENT_ID}
        >
            <HookedBrowserRouter>
                <App/>
                <KToaster/>
            </HookedBrowserRouter>
        </Auth0Provider>
    </ReduxProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

